import { AppContext } from '@/contexts/app-context';
import { useGetProducts } from '@/hooks/use-get-products';
import { useContext, useEffect, useState } from 'react';
import { ProductType } from '../types';

type UseProductsProps = {
    hiddenProducts?: string[];
    productOrder?: string[];
};

export const useProducts = ({ hiddenProducts = [], productOrder = [] }: UseProductsProps = {}) => {
    const context = useContext(AppContext);
    const { data: fetchedProducts, isLoading: productsLoading } = useGetProducts(context, true);
    const [chosenProduct, setChosenProduct] = useState<ProductType | null>(null);
    const [hasInitialized, setHasInitialized] = useState(false);

    // Set preselected product (first visible in sorted order) when products load
    useEffect(() => {
        if (!hasInitialized && fetchedProducts?.length) {
            // Filter visible products
            const visibleProducts = fetchedProducts.filter(p => !hiddenProducts.includes(p.code));

            // Sort by productOrder
            const sortedProducts =
                productOrder.length > 0
                    ? [...visibleProducts].sort((a, b) => {
                          const indexA = productOrder.indexOf(a.code);
                          const indexB = productOrder.indexOf(b.code);
                          if (indexA === -1) return 1;
                          if (indexB === -1) return -1;
                          return indexA - indexB;
                      })
                    : visibleProducts;

            // Preselect first visible product in sorted order
            const preselected = sortedProducts[0];
            if (preselected) {
                setChosenProduct(preselected);
            }
            setHasInitialized(true);
        }
    }, [fetchedProducts, hiddenProducts, productOrder, hasInitialized]);

    return {
        products: fetchedProducts,
        productsLoading,
        chosenProduct,
        setChosenProduct,
    };
};
